import styled from "styled-components"

export const P = styled.p`
  margin: ${props => (props.margin ? props.margin : 0)};
  font-size: ${props => {
    switch (props.size) {
      case "medium":
        return "1.125rem"
      case "small":
        return "1rem"
    }
  }};
`
export const H1 = styled.h1`
  font-size: 2.25rem;
  line-height: 2rem;
`

export const H2 = styled.h1`
  font-size: 2.25rem;
  line-height: 2rem;
`
